import StyleSheet from 'react-native-media-query';
import lodashIsUndefined from 'lodash/isUndefined';

import BreakPoints from '../../../../Theme/styles/breakpoints';

import RatingSelector from '../../../Filter/RatingSelector';

import useModalPrompt from './hooks/useModalPrompt';
import ModalPrompt from './ModalPrompt';

const defaultValue = 4;
const RatingSelectorModal = ({ modalId, payload }) => {
  const { hideModalPrompt } = useModalPrompt();

  const disableReset = lodashIsUndefined(payload.value);

  const _onClose = () => {
    hideModalPrompt(modalId, {});
  };

  const _onButtonPress = (rating?: number) =>
    hideModalPrompt(modalId, { value: rating || null });

  return (
    <ModalPrompt
      id={modalId}
      title="Ratings"
      dataSet={{ media: ids.ratingModal }}
      mainContentWrapperStyle={styles.ratingModal}
      hasHeader
      hasHeaderLine
      onCloseButtonClick={_onClose}
      closeOnDocumentClick={false}
      scrollEnabled={false}
    >
      <RatingSelector
        disableReset={disableReset}
        rating={disableReset ? defaultValue : payload.value}
        onViewResult={_onButtonPress}
        onReset={() => _onButtonPress()}
      />
    </ModalPrompt>
  );
};
const { ids, styles } = StyleSheet.create({
  ratingModal: {
    [`@media ${BreakPoints.xs}`]: {
      width: 380,
    },
    [`@media ${BreakPoints.sm}`]: {
      width: 400,
    },
    [`@media ${BreakPoints.md}`]: {
      width: 420,
    },
    [`@media ${BreakPoints.lg}`]: {
      width: 440,
    },
    [`@media ${BreakPoints.xl}`]: {
      width: 460,
    },
    [`@media ${BreakPoints.xxl}`]: {
      width: 480,
    },
  },
});

export default RatingSelectorModal;
